import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import VConsole from "vconsole";

// vConsole for debugging in Telegram Mini App
// new VConsole();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
